import React from "react";
import ProfileOverviewMap from "@images/profile/profileOverviewMap.svg";

const ProfileHistory = ({children,onClick,btnLabel,btnIcon}) => {
  const routeHistory = [
    {
      label: "Route history",
      imgurl: ProfileOverviewMap,
    },
    {
      label: "Route history",
      imgurl: ProfileOverviewMap,
    },
  ];
  return (
    <div className="gap-[24px] flex flex-col bg-white p-[16px] rounded-lg">
        {routeHistory.map((item,index) =>(
      <div key={index}>
        <p className="text-[13px] text-black font-medium mb-[4px]">{item.label}</p>
        <div className="border-1 border-gray border-solid rounded-2xl">
          <img src={item.imgurl} className="w-full rounded-2xl" />
        </div>
      </div>
        ))}
        {children && <div>{children}</div> }
        <div>
            <button className="bg-black p-[16px] w-full items-center rounded-full text-white flex gap-[10px] justify-center text-[20px] leading-[28px] font-semibold" onClick={onClick}>
            {btnIcon && <span>{btnIcon}</span>}
                {btnLabel}
            </button>
        </div>
    </div>
  );
};

export default ProfileHistory;
